import React, { Fragment } from 'react'
import GoogleLogo from 'images/GoogleLogo'
import styled from 'react-emotion'
import withProps from 'recompose/withProps'
import urlForProvider from '../utils/urlForProvider'
import { Button, color, spacer, transparentize } from 'stylist'

const GoogleButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 1px solid;
  background: ${color('white')};
  color: ${color('black')};
  border-color: ${transparentize('slate', 0.2)};

  svg {
    margin-right: ${spacer(2)};
  }
`

export default withProps(({ label, onError, valid }) => ({
  children: (
    <Fragment>
      <GoogleLogo alt="Google" />
      Sign in with Google
    </Fragment>
  ),

  onClick: e => {
    e.preventDefault()
    if (valid) {
      window.location.replace(urlForProvider('google'))
    } else {
      onError()
    }
  }
}))(GoogleButton)



// WEBPACK FOOTER //
// ./src/components/GoogleButton.js